import React, { useEffect, useState } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import EnterpriseLogo from '#coreComponents/EnterpriseLogo/EnterpriseLogo';

export type InstitutionLogoProps = BoxProps & {
  src: string;
  alt: string;
};

const InstitutionLogo: React.FC<InstitutionLogoProps> = ({
  src,
  alt,
  ...boxProps
}) => {
  const [hasError, setHasError] = useState(false);

  // Reset a prior load failure when the src changes (e.g. component reused for a different
  // institution without remounting), so a stale error doesn't stick the fallback indefinitely.
  useEffect(() => {
    setHasError(false);
  }, [src]);

  if (!src || hasError) {
    return (
      <Box
        role="img"
        aria-label={alt}
        color="black"
        bg="transparent"
        {...boxProps}
      >
        <EnterpriseLogo width="100%" height="100%" />
      </Box>
    );
  }

  return (
    <Box
      as="img"
      src={src}
      alt={alt}
      onError={() => setHasError(true)}
      {...boxProps}
    />
  );
};

export default InstitutionLogo;
